import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import CandyCartApp from '../../CandyCartApp';
import { handleDiscounts } from '../../shared/utils/discounts';
import cleanupCartData from '../../utils/cart-cleanup';
import captureException from '../../utils/sentry';
import { logError, logInfo } from '../../shared/utils/logging';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import Buttons from './buttons';
import { AppInfoCandyRack } from '../../shared/types/AppsInfo';

let root: Root | null = null;

export default function init(
  isDefaultInit: boolean = true,
  appsInfo: AppInfoCandyRack,
) {
  try {
    logInfo('loaded 🎉', REGISTERED_APPS.CHECKOUT_BUTTON);
    const buttons: Buttons = new Buttons('checkoutButtonClicked');

    let rootElement = document.getElementById('candycart-root');

    if (!rootElement) {
      document.body.insertAdjacentHTML(
        'beforeend',
        '<div id="candycart-root"></div>',
      );
      rootElement = document.getElementById('candycart-root');
    }

    if (rootElement) {
      if (root) {
        root.unmount();
      }

      root = createRoot(rootElement);
      root.render(<CandyCartApp buttons={buttons} appsInfo={appsInfo} />);
    }

    if (isDefaultInit) {
      handleDiscounts(REGISTERED_APPS.CHECKOUT_BUTTON);
      cleanupCartData(REGISTERED_APPS.CHECKOUT_BUTTON);
    }
  } catch (error) {
    logError(error);
    captureException(error as Error);
  }
}
